import { initializeMessageResource } from "@vrf/fr-vrf-core-react";
import { ScreenMessageEnUs } from "./messages/screen-message-en-US";
import { EN_US } from "./i18n";

const messageResources = [{ locale: EN_US, resource: ScreenMessageEnUs }];

initializeMessageResource(messageResources);
